<div class="new-content" *ngIf="!pane || !pane.contentItems; else contentBlock">
  <loading-line *ngIf="pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
</div>

<app-skeleton *ngIf="showSkeleton && pane.display_mode !== 'row'" [stats]="'my-classes-classrooms'"></app-skeleton>

<ng-template #contentBlock>
  <div *ngIf="!showSkeleton" class="content" [class.cell-row]="pane.display_mode === 'row'">
    <app-chapter [link]="blockTitle?.add_link" [title]="blockTitle?.title"></app-chapter>

    <app-filter-content
      *ngIf="pane.display_mode === 'row' && !pane.hidden_filter_block"
      [top]="isAsIfTeacher"
      [tabs]="tabs"
      [activeTab]="activeTab"
      (onSelect)="activateTab($event)">
      <ng-template action [ngIf]="isAsIfTeacher">
        <on-ui-button
          *ngIf="!deviceService.isMobile()"
          label="my-classes.actions.create-classroom"
          class="poutline"
          (onclick)="onCreateRoom()">
        </on-ui-button>

        <div *ngIf="deviceService.isMobile()" class="create-item" (click)="onCreateRoom()">
          <div class="action-icon-wrap">
            <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
          </div>
        </div>
      </ng-template>
    </app-filter-content>

    <div *ngIf="classrooms.length" class="scroll">
      <div class="classroom-list" [class.cell-row]="pane.display_mode === 'row'">
        <div *ngFor="let classroom of classroomsSliced; trackBy: trackByFn" class="classroom-item">
          <app-classroom-mini
            [display_mode]="pane.display_mode"
            [me]="me"
            [classroom]="classroom"
            [pins]="pins$ | async"
            (edit)="onEdit($event)"
            (update)="updateList()">
          </app-classroom-mini>
        </div>
      </div>

      <ng-container *ngIf="pane.display_mode === 'row'">
        <!--Pagination-->
        <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
        <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>
      </ng-container>
    </div>

    <app-empty *ngIf="showEmptyContent" [empty]="emptyContent" (onClick)="onCreateRoom()"></app-empty>
    <ng-container *ngIf="!classrooms.length && pane.display_mode === 'row'" [ngTemplateOutlet]="noContentStub">
    </ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    [icon]="'stat-class-2'"
    [text]="isAsIfTeacher ? 'my-classes.stub.stub5' : 'my-classes.stub.stub5_1'">
  </app-no-content-stub>
</ng-template>

<app-modal *ngIf="classroomModalOpened && !deviceService.isMobile()" [canClose]="false" (closed)="onCloseModal()">
  <app-modal-body>
    <app-classroom-form-wrapper [classroom]="classroom" (saved)="onSavedClassroom()" (canceled)="onCloseModal()">
    </app-classroom-form-wrapper>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="classroomModalOpened && deviceService.isMobile()" (closed)="onCloseModal()">
  <app-mobile-modal-title>{{
    (classroom?.id ? 'classrooms.form.titles.edit' : 'classrooms.form.titles.create') | customLocale
  }}</app-mobile-modal-title>
  <app-mobile-modal-body>
    <app-classroom-form-wrapper [classroom]="classroom" (saved)="onSavedClassroom()" (canceled)="onCloseModal()">
    </app-classroom-form-wrapper>
  </app-mobile-modal-body>
</app-mobile-modal>
